<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="private-offers">
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="unlockPrivateOffersEnabled">Private Offers
          <i class="pi pi-info-circle"
             pTooltip="Enable account-level private offers, including Unlock/Reveal experiences across the website."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <p-toggleswitch
          id="unlockPrivateOffersEnabled"
          formControlName="unlockPrivateOffersEnabled">
        </p-toggleswitch>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="includePrivateOffersInExternalAdvertising">Include Private Offers in External Advertising</label>
      </div>
      <div class="field-switch-label">
        <p-toggleswitch
          id="includePrivateOffersInExternalAdvertising"
          formControlName="includePrivateOffersInExternalAdvertising">
        </p-toggleswitch>
      </div>
    </div>
    <h3 class="section-heading">Savings Message</h3>
    <div class="savings-message-section">
      <div class="tab-panel-input-wrapper">
        <div class="field-input-label tab-input-label label-field">
          <label for="displaySavingsMessage">Display Savings Message
            <i class="pi pi-info-circle"
               pTooltip="Displays the unlocked dollar amount savings message in the VDP Offer Display after a Private Offer is successfully unlocked. Offer recalculations will occur regardless of whether this message is shown."
               tooltipPosition="top"></i></label>
        </div>
        <div class="field-switch-label">
          <p-toggleswitch
            id="displaySavingsMessage"
            formControlName="displaySavingsMessage">
          </p-toggleswitch>
        </div>
      </div>
      <div class="tab-panel-input-wrapper">
        <div class="field-input-label tab-input-label label-field">
          <label for="savingsMessage">Savings Message
            <i class="pi pi-info-circle"
               pTooltip="The Savings message appears immediately after the flat dollar amount savings displayed in the VDP Offer Display."
               tooltipPosition="top"></i></label>
        </div>
        <div class="field-switch-label">
          <input id="savingsMessage"
                 type="text"
                 pInputText
                 class="text-input savings-message-input"
                 formControlName="savingsMessage"
                 maxlength="255" />
        </div>
      </div>
      <div class="tab-panel-input-wrapper">
        <div class="field-input-label tab-input-label label-field">
          <label for="savingsMessageBackgroundColor">Savings Message Background Color
            <i class="pi pi-info-circle"
               pTooltip="Controls the background color of the unlocked Savings Message displayed in the VDP Offer Display."
               tooltipPosition="top"></i></label>
        </div>
        <div class="field-switch-label">
          <div class="savings-message-background-color-control">
            <input id="savingsMessageBackgroundColor"
                   type="color"
                   formControlName="savingsMessageBackgroundColor"
                   class="savings-message-background-color-swatch" />
            <input
              type="text"
              class="savings-message-background-color-hex"
              [value]="form?.get('savingsMessageBackgroundColor')?.value"
              (input)="form?.get('savingsMessageBackgroundColor')?.setValue($any($event.target).value); form?.get('savingsMessageBackgroundColor')?.markAsDirty()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
